import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=75e88066&scoped=true&"
import script from "./copy.js?vue&type=script&lang=js&"
export * from "./copy.js?vue&type=script&lang=js&"
import style0 from "./copy.vue?vue&type=style&index=0&id=75e88066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e88066",
  null
  
)

export default component.exports